import { initMap, equalCols, getCookie } from '../functions';
import Swal from 'sweetalert2'
import noUiSlider from 'nouislider';

$(document).ready(function() {

	const daciaOffeersModule = {
        isLoading: false,
        init() {
            $(document).on('click', '.dacia-offers-search-btn', this, this.search);
            $(document).on('click', '.dacia-offers-reset-filters-btn', this, this.resetFilters);
            $(document).on('change', '.dacia-offers-search-field', this, this.updateFilters);
            $(document).on('change', '#sort', this, this.sort);
            $(document).on('change', '#ipp', this, this.itemsPerPage);
            $(document).on('click', '.dacia-offer-request-show-form', this, this.from);
            $(document).on('click', '#dacia-offer-request-send-btn', this, this.send);

            var slider = document.getElementById('slider-range');
            if (slider) {
                this.initPriceSlider(slider);
            }

            var filterSlider = document.getElementById('filter-slider-range');
            if (filterSlider) {
                this.initPriceSlider(filterSlider);
            }
            
            $(document).on('click', '#dacia-offer-request .radio-line .form-check', function(){
                $('#dacia-offer-request .radio-line .form-check').removeClass("selected");
                $('#dacia-offer-request .radio-line .form-check-input').prop('checked', false);
                $(this).addClass("selected");
                $(this).find(".form-check-input").prop('checked', true);
            });
            $(document).on('change', '#or_person_type', function(e) {
                if ($(this).is(':checked')) {
                    $('#or-company-wrapper').show();
                } else {
                    $('#or-company-wrapper').hide();
                }

                if ($(document).width() > 1025) {
                    equalCols('.offer-request-eq-height');
                }
            });
        },
        resetFilters(event) {
            const _this = event.data;
            event.preventDefault();

            var values = 'model=';
            values += '&min_price=';
            values += '&max_price=';
            values += '&fuel=';
            values += '&color=';
            values += '&transmission=';
            values += '&_token=' + $('meta[name="csrf-token"]').attr('content');
            $.ajax({
                type: "POST",
                url: baseURL + "/dacia-offers/filters",
                data: values,
                success: function(response) {
                    
                    if (response.models) {
                        const $model = $('#model');
                        $model.find('option:not(:first)').remove();
                        response.models.forEach(function(model) {
                            $model.append($('<option>', { value: model, text: model }));
                        });
                    }

                    if (response.fuelTypes) {
                        const $fuel = $('#fuel');
                        $fuel.find('option:not(:first)').remove();
                        response.fuelTypes.forEach(function(fuel) {
                            $fuel.append($('<option>', { value: fuel, text: fuel }));
                        });
                    }

                    if (response.colors) {
                        const $color = $('#color');
                        $color.find('option:not(:first)').remove();
                        response.colors.forEach(function(color) {
                            $color.append($('<option>', { value: color, text: color }));
                        });
                    }

                    if (response.transmissions) {
                        const $transmission = $('#transmission');
                        $transmission.find('option:not(:first)').remove();
                        Object.entries(response.transmissions).forEach(function([value, label]) {
                            $transmission.append($('<option>', { value: value, text: label }));
                        });
                    }

                    if (response.minMaxPrice) {
                        $('#price_min').val('');
                        $('#price_max').val('');
                        $('.selected-min-price').text(response.minMaxPrice.min);
                        $('.selected-max-price').text(response.minMaxPrice.max);
                        // Optionally update slider if needed
                        if ($('#filter-slider-range')[0] && $('#filter-slider-range')[0].noUiSlider) {
                            $('#filter-slider-range')[0].noUiSlider.set([response.minMaxPrice.min, response.minMaxPrice.max]);
                        }
                    }
                },
                error(error) {
                    
                },
            });
        },
        updateFilters(event) {
            const _this = event.data;
            event.preventDefault();
            const type = $(this).attr('name');

            $('.dacia-offers-reset-filters-btn').show();

            var values = 'type=' + type;
            values += '&model=' + encodeURIComponent($('#model option:selected').val() || '');
            values += '&min_price=' + encodeURIComponent($('#price_min').val() || '');
            values += '&max_price=' + encodeURIComponent($('#price_max').val() || '');
            values += '&fuel=' + encodeURIComponent($('#fuel option:selected').val() || '');
            values += '&color=' + encodeURIComponent($('#color option:selected').val() || '');
            values += '&transmission=' + encodeURIComponent($('#transmission option:selected').val() || '');
            values += '&_token=' + $('meta[name="csrf-token"]').attr('content');
            $.ajax({
                type: "POST",
                url: baseURL + "/dacia-offers/filters",
                data: values,
                success: function(response) {
                    
                    if (response.models && type != 'model') {
                        const $model = $('#model');
                        const selectedModel = $model.val();
                        $model.find('option:not(:first)').remove();
                        response.models.forEach(function(model) {
                            $model.append($('<option>', { value: model, text: model }));
                        });
                        if (selectedModel && response.models.includes(selectedModel)) {
                            $model.val(selectedModel);
                        }
                    }

                    if (response.fuelTypes && type != 'fuel') {
                        const $fuel = $('#fuel');
                        const selectedFuel = $fuel.val();
                        $fuel.find('option:not(:first)').remove();
                        response.fuelTypes.forEach(function(fuel) {
                            $fuel.append($('<option>', { value: fuel, text: fuel }));
                        });
                        if (selectedFuel && response.fuelTypes.includes(selectedFuel)) {
                            $fuel.val(selectedFuel);
                        }
                    }

                    if (response.colors && type != 'color') {
                        const $color = $('#color');
                        const selectedColor = $color.val();
                        $color.find('option:not(:first)').remove();
                        response.colors.forEach(function(color) {
                            $color.append($('<option>', { value: color, text: color }));
                        });
                        if (selectedColor && response.colors.includes(selectedColor)) {
                            $color.val(selectedColor);
                        }
                    }

                    if (response.transmissions && type != 'transmission') {
                        const $transmission = $('#transmission');
                        const selectedTransmission = $transmission.val();
                        $transmission.find('option:not(:first)').remove();
                        Object.entries(response.transmissions).forEach(function([value, label]) {
                            $transmission.append($('<option>', { value: value, text: label }));
                        });
                        if (selectedTransmission && response.transmissions[selectedTransmission]) {
                            $transmission.val(selectedTransmission);
                        }
                    }

                    if (response.minMaxPrice) {
                        $('.selected-min-price').text(response.minMaxPrice.min);
                        $('.selected-max-price').text(response.minMaxPrice.max);
                        // Optionally update slider if needed
                        if ($('#filter-slider-range')[0] && $('#filter-slider-range')[0].noUiSlider) {
                            $('#filter-slider-range')[0].noUiSlider.set([response.minMaxPrice.min, response.minMaxPrice.max]);
                        }
                    }
                },
                error(error) {
                    
                },
            });
        },
        send(event) {
            const _this = event.data;
            event.preventDefault();
            const id = $(this).data('id');

            if (_this.isLoading) {
                return false;
            }

            let errors = false;
            $('#dacia-offer-request').find('.form-control').removeClass('is-invalid');
            $('#dacia-offer-request').find('.form-check-input').removeClass('is-invalid');
            $('#or-notifications').html('');

            if($('#or_person_type').is(':checked')) {
                if ($('#company').val() == '') {
                    $('#company').addClass('is-invalid');
                    errors = true;
                }
                if ($('#cui').val() == '') {
                    $('#cui').addClass('is-invalid');
                    errors = true;
                }
            }
            if ($('#salutation option:selected').val() == '') {
                $('#salutation').addClass('is-invalid');
                errors = true;
            }
            if ($('#first_name').val() == '') {
                $('#first_name').addClass('is-invalid');
                errors = true;
            }
            if ($('#last_name').val() == '') {
                $('#last_name').addClass('is-invalid');
                errors = true;
            }
            if ($('#email').val() == '') {
                $('#email').addClass('is-invalid');
                errors = true;
            }
            if ($('#phone').val() == '') {
                $('#phone').addClass('is-invalid');
                errors = true;
            }
            if ($('#locality option:selected').val() == '') {
                $('#locality').addClass('is-invalid');
                errors = true;
            }
            // if ($('#state_id option:selected').val() == '') {
            // 	$('#state_id').addClass('is-invalid');
            // 	errors = true;
            // }
            if ($('#intend_to_buy_in option:selected').val() == '') {
                $('#intend_to_buy_in').addClass('is-invalid');
                errors = true;
            }
            if (!$('#offer-request-terms-and-condition').is(":checked")) {
                $('#offer-request-terms-and-condition').addClass('is-invalid');
                errors = true;
            }

            if (errors) {
                $('#or-notifications').html('<div class="alert alert-danger" role="alert">Va rugam completati toate campurile!</div>');
                document.getElementById('dacia-offer-request').scrollTop = 0;
                return false;
            }

            //Loading...
            _this.isLoading = true;
            let element = this;
            $(element).find('i').show();

            var values = 'id=' + id;
            values += '&salutation=' + $('#salutation option:selected').val();
            values += '&person_type=' + ($('#or_person_type').is(':checked')?1:0);
            values += '&company=' + $('#company').val();
            values += '&cui=' + $('#cui').val();
            values += '&first_name=' + $('#first_name').val();
            values += '&last_name=' + $('#last_name').val();
            values += '&email=' + $('#email').val();
            values += '&phone=' + $('#phone').val();
            values += '&locality=' + $('#locality option:selected').val();
            //values += '&state_id=' + $('#state_id option:selected').val();
            values += '&intend_to_buy_in=' + $('#intend_to_buy_in option:selected').val();
            values += '&message=' + $('#message').val();
            values += '&newsletter=' + ($('.offer-request-newsletter:checked').val()?$('.offer-request-newsletter:checked').val():0);
            values += '&_token=' + $('#_token_or').val();
            $.ajax({
                type: "POST",
                url: baseURL + "/dacia-offer-request/send",
                data: values,
                success: function(response) {
                    _this.isLoading = false;
                    $(element).find('i').hide();

                    if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $('#' + errorKey).addClass('is-invalid');
                                //errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }
                        $('#or-notifications').html('<div class="alert alert-danger" role="alert">Va rugam completati toate campurile!</div>');
                        return false;
                    }

                    if (response.status == 1) {
                        $('#dacia-offer-request').modal('hide');
                        $('#dacia-offer-request').on('hidden.bs.modal', function() {
                            $('#offer-request-container').html('');
                        });

                        Swal.fire({
                            icon: 'success',
                            title: 'Success!',
                            html: formSuccessMessage
                        });

                        if (cookies_advertisement == 1) {
                            gtag('event', 'conversion', {'send_to': 'AW-732195211/z_5UCI7a8-cBEIvTkd0C'});
                        }

                        if (cookies_advertisement == 1 || cookies_social == 1) {
                            fbq('track', 'Lead');
                        }

                        return false;
                    }

                    $('#or-notifications').html('<div class="alert alert-danger" role="alert">'+response.message+'</div>');
                },
                error(error) {
                    _this.isLoading = false;
                    $(element).find('i').hide();
                },
            });
        },
        from(event) {
            const _this = event.data;
            event.preventDefault();
            const id = $(this).data('id');

            if (_this.isLoading) {
                return false;
            }

            //Loading...
            _this.isLoading = true;
            let element = this;

            var values = 'id=' + id;
            $.ajax({
                type: "GET",
                url: baseURL + "/dacia-offer-request/get",
                data: values,
                success: function(response) {
                    $(".header").removeClass('mobile-meniu-open');

                    if (response == 'invalid-id') {
                        _this.isLoading = false;
                        alert('Invalid offer ID');
                        return false;
                    }

                    $('#offer-request-container').html(response);
                    $('#dacia-offer-request').modal('show');

                    $('#dacia-offer-request').on('shown.bs.modal', function (e) {
                        if ($(document).width() > 1025) {
                            equalCols('.offer-request-eq-height');
                        }
                    });

                    _this.isLoading = false;
                },
                error(error) {
                    _this.isLoading = false;
                },
            });
        },
        initPriceSlider(slider) {
            const priceMin = 1 * $(slider).data('price-min');
            const priceMax = 1 * $(slider).data('price-max');
            let url = $(slider).data('url');
            let selectedMinPrice = priceMin;
            let selectedMaxPrice = priceMax;
            if ($('.selected-min-price').length > 0) {
                selectedMinPrice = parseInt($('.selected-min-price').text());
            }
            if ($('.selected-max-price').length > 0) {
                selectedMaxPrice = parseInt($('.selected-max-price').text());
            }

            noUiSlider.create(slider, {
                start: [selectedMinPrice, selectedMaxPrice],
                connect: true,
                range: {
                    'min': priceMin,
                    'max': priceMax
                },
                step: 1,
                format: {
                    to: function (value) {
                        return Math.round(value);
                    },
                    from: function (value) {
                        return Number(value);
                    }
                }
            });

            slider.noUiSlider.on('slide', function (values, handle) {
                const minPrice = values[0];
                const maxPrice = values[1];

                // Update hidden inputs
                $('#price_min').val(minPrice);
                $('#price_max').val(maxPrice);

                // Update span text
                $('.selected-min-price').text(minPrice);
                $('.selected-max-price').text(maxPrice);
            });

            slider.noUiSlider.on('end', function (values, handle) {
                const minPrice = values[0];
                const maxPrice = values[1];

                if (url != '') {
                    if (url.indexOf('?') === -1) {
                        url += '?min_price=' + encodeURIComponent(minPrice) + '&max_price=' + encodeURIComponent(maxPrice);
                    } else {
                        url += '&min_price=' + encodeURIComponent(minPrice) + '&max_price=' + encodeURIComponent(maxPrice);
                    }
                    window.location = url;
                } else {

                    $('.dacia-offers-reset-filters-btn').show();

                    let type = 'price';
                    //for search widget
                    var values = 'type=' + type;
                    values += '&model=' + encodeURIComponent($('#model option:selected').val() || '');
                    values += '&min_price=' + encodeURIComponent($('#price_min').val() || '');
                    values += '&max_price=' + encodeURIComponent($('#price_max').val() || '');
                    values += '&fuel=' + encodeURIComponent($('#fuel option:selected').val() || '');
                    values += '&color=' + encodeURIComponent($('#color option:selected').val() || '');
                    values += '&transmission=' + encodeURIComponent($('#transmission option:selected').val() || '');
                    values += '&_token=' + $('meta[name="csrf-token"]').attr('content');
                    $.ajax({
                        type: "POST",
                        url: baseURL + "/dacia-offers/filters",
                        data: values,
                        success: function(response) {
                            
                            if (response.models && type != 'model') {
                                const $model = $('#model');
                                const selectedModel = $model.val();
                                $model.find('option:not(:first)').remove();
                                response.models.forEach(function(model) {
                                    $model.append($('<option>', { value: model, text: model }));
                                });
                                if (selectedModel && response.models.includes(selectedModel)) {
                                    $model.val(selectedModel);
                                }
                            }

                            if (response.fuelTypes && type != 'fuel') {
                                const $fuel = $('#fuel');
                                const selectedFuel = $fuel.val();
                                $fuel.find('option:not(:first)').remove();
                                response.fuelTypes.forEach(function(fuel) {
                                    $fuel.append($('<option>', { value: fuel, text: fuel }));
                                });
                                if (selectedFuel && response.fuelTypes.includes(selectedFuel)) {
                                    $fuel.val(selectedFuel);
                                }
                            }

                            if (response.colors && type != 'color') {
                                const $color = $('#color');
                                const selectedColor = $color.val();
                                $color.find('option:not(:first)').remove();
                                response.colors.forEach(function(color) {
                                    $color.append($('<option>', { value: color, text: color }));
                                });
                                if (selectedColor && response.colors.includes(selectedColor)) {
                                    $color.val(selectedColor);
                                }
                            }

                            if (response.transmissions && type != 'transmission') {
                                const $transmission = $('#transmission');
                                const selectedTransmission = $transmission.val();
                                $transmission.find('option:not(:first)').remove();
                                Object.entries(response.transmissions).forEach(function([value, label]) {
                                    $transmission.append($('<option>', { value: value, text: label }));
                                });
                                if (selectedTransmission && response.transmissions[selectedTransmission]) {
                                    $transmission.val(selectedTransmission);
                                }
                            }
                        },
                        error(error) {
                            
                        },
                    });
                    //for search widget

                }
            });
        },
        sort(event) {
            const _this = event.data;

            let url = $(this).data('url');
            const sort = $(this).find(':selected').val();

            if (sort) {
                if (url.indexOf('?') === -1) {
                    url += '?sort=' + encodeURIComponent(sort);
                } else {
                    url += '&sort=' + encodeURIComponent(sort);
                }
            }

            window.location = url;
        },
        itemsPerPage(event) {
            const _this = event.data;

            let url = $(this).data('url');
            const ipp = $(this).find(':selected').val();

            if (ipp) {
                if (url.indexOf('?') === -1) {
                    url += '?ipp=' + encodeURIComponent(ipp);
                } else {
                    url += '&ipp=' + encodeURIComponent(ipp);
                }
            }

            window.location = url;
        },
		search(event) {
			const _this = event.data;
            
            let url = $(this).data('url');

            const params = {};

            // Get values from selects
            const model = $('#model').val();
            if (model) params.model = model;

            const fuel = $('#fuel').val();
            if (fuel) params.fuel = fuel;

            const transmission = $('#transmission').val();
            if (transmission) params.transmission = transmission;

            const color = $('#color').val();
            if (color) params.color = color;

            // Get values from price inputs
            const priceMin = $('#price_min').val();
            if (priceMin) params.min_price = priceMin;

            const priceMax = $('#price_max').val();
            if (priceMax) params.max_price = priceMax;

            // Build query string
            const queryString = $.param(params);

            // Append query string to URL
            if (queryString) {
                if (url.indexOf('?') === -1) {
                    url += '?' + queryString;
                } else {
                    url += '&' + queryString;
                }
            }
			
            window.location = url;
		}
    };

    if ($('.dacia-offers-module').length) {
        daciaOffeersModule.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/dacia-offers.js